/**
 * +field: the "[T] Talk to Elder Rowan" prompt shown when the hero stands next to a town NPC
 * (worldApp sets fieldView.prompt). Clicking it is the same as pressing T.
 */
import type { HudWidget } from '../widgets';
import { el, setText } from '../dom';
import { fieldView } from '../../world/fieldView';

export class NpcPrompt implements HudWidget {
  readonly root: HTMLElement;
  private readonly name: HTMLElement;
  private readonly title: HTMLElement;
  private version = -1;

  constructor(hudRoot: HTMLElement) {
    this.root = el('div', 'fx-prompt hk-hit hk-hidden', hudRoot);
    el('span', 'fx-prompt-key', this.root, 'T');
    const text = el('span', 'fx-prompt-text', this.root);
    this.name = el('b', 'fx-prompt-name', text);
    this.title = el('span', 'fx-prompt-title', text);
    this.root.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const p = fieldView.prompt;
      if (p) fieldView.actions?.interact(p.npcId);
    });
  }

  update(): void {
    const v = fieldView;
    if (v.promptVersion === this.version) return;
    this.version = v.promptVersion;
    const p = v.active ? v.prompt : null;
    this.root.classList.toggle('hk-hidden', !p);
    if (!p) return;
    this.root.classList.toggle('fx-prompt-use', p.verb === 'use');
    this.root.classList.toggle('fx-prompt-gather', p.verb === 'gather'); // +prof
    setText(this.name, p.name);
    setText(this.title, p.title);
  }

  dispose(): void {
    this.root.remove();
  }
}
